import { lazy, Suspense } from "react";

import {
  PropHeroSpinner,
  SPINNER_COLOR,
  SPINNER_SIZE,
} from "@prophero-ds/react-components";

import ScreenManagerLayout from "./components/ScreenManagerLayout";

/**
 * Main App Component
 * Conditionally loads DevScreenManager or ProdScreenManager based on environment
 * Uses React.lazy() for optimal code splitting and tree-shaking
 */

// Conditionally lazy-load the appropriate screen manager
const ScreenManager = lazy(() => {
  if (import.meta.env.DEV) {
    return import("./DevScreenManager");
  } else {
    return import("./ProdScreenManager");
  }
});

export default function App() {
  return (
    <ScreenManagerLayout>
      <Suspense
        fallback={
          <div className="flex min-h-screen items-center justify-center">
            <PropHeroSpinner
              color={SPINNER_COLOR.BRAND}
              size={SPINNER_SIZE.LARGE}
            />
          </div>
        }
      >
        <ScreenManager />
      </Suspense>
    </ScreenManagerLayout>
  );
}
